import { configureStore } from '@reduxjs/toolkit';
import Log from 'utils/log';
import { toastersSliceHandler } from 'modules/shared/stores/toasters-slice-handler';
import { companySettingsSliceHandler } from 'modules/settings/stores/company-settings-slice-handler';
import { contactsSliceHandler } from 'modules/contacts/stores/contacts-slice-handler';
import { userSettingsSliceHandler } from 'modules/settings/stores/user-settings-slice-handler';
import { meetingRoomsSliceHandler } from 'modules/meeting-rooms/stores/meeting-rooms-slice-handler';
import { userGroupsSliceHandler } from 'modules/contacts/stores/user-groups-slice-handler';
import { videoStreamingSliceHandler } from 'modules/video-popups/stores/video-streaming-slice-handler';
import { masterPagesSliceHandler } from 'master-pages/stores/master-pages-slice-handler';
import { soundSettingsSliceHandler } from 'modules/sound-settings/stores/sound-settings-slice-handler';
import { reachBackRequestsSliceHandler } from 'modules/reach-back-requests/stores/reach-back-requests-slice-handler';
import { topBarSliceHandler } from 'modules/top-bar/stores/top-bar-slice-handler';
import { storageQuotaSliceHandler } from 'modules/top-bar/stores/storage-quota-slice-handler';
import { guestInvitationSliceHandler } from 'modules/contacts/stores/guest-invitation-slice-handler';
import { myRulesPackagesSliceHandler } from 'modules/top-bar/stores/my-rules-packages-slice-handler';
import { keyValueSliceHandler } from 'modules/shared/stores/key-value-slice-handler';
import { portalsSliceHandler } from './portals-slice-handler';
import { floatingWindowsSliceHandler } from './floating-windows-slice-handler';
import { slidingLayersSliceHandler } from './sliding-layers-slice-handler';

const reducer = {};
const sliceHandlers = [
    companySettingsSliceHandler,
    userSettingsSliceHandler,
    toastersSliceHandler,
    contactsSliceHandler,
    meetingRoomsSliceHandler,
    portalsSliceHandler,
    userGroupsSliceHandler,
    floatingWindowsSliceHandler,
    slidingLayersSliceHandler,
    topBarSliceHandler,
    videoStreamingSliceHandler,
    masterPagesSliceHandler,
    soundSettingsSliceHandler,
    reachBackRequestsSliceHandler,
    storageQuotaSliceHandler,
    guestInvitationSliceHandler,
    myRulesPackagesSliceHandler,
    keyValueSliceHandler,
];

// set up the reducers
sliceHandlers.forEach((handler) => {
    const handlerKey = handler.constructor.name.replace('Handler', '');
    reducer[handlerKey[0].toLowerCase() + handlerKey.substr(1)] = handler.getReducer();
});
// build up the store
const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});
// propagate the store in handlers
sliceHandlers.forEach((handler) => {
    handler.setStore(store);
});

Log.debug('STORE', `App store has been set with ${sliceHandlers.length} slices: ${Object.keys(reducer).join(',')}`);

/**
 * Access a slixce from the base store.
 * This function is useful and should be used ONLY to avoid circular dependencies.
 * Example: ContactsSliceHandler imports ContactUtil, and ContactUtil imports ContactsSliceHandler.
 * @param {string} sliceName The name of the slice handler. Ex contactsSlice (It is set by every handler in its constructor.)
 * @return {(CompanySettingsSliceHandler|UserSettingsSliceHandler|ToastersSliceHandler|ContactsSliceHandler|MeetingRoomsSliceHandler)||null}
 */
export function getSlice(sliceName) {
    const match = sliceHandlers.filter((handler) => handler.getSliceName() === sliceName);

    if (match.length === 0) {
        return null;
    }

    return match[0];
}

export default store;
